import { defineStore } from "pinia";
import { ref } from "vue";

export const useAuthStore = defineStore("auth", () => {
	// 認証状態
	const isAuthenticated = ref(false);
	// ユーザー情報
	const userId = ref("");
	const userName = ref("");
	const houseId = ref("");

	return {
		isAuthenticated,
		userId,
		userName,
		houseId,
	};
});
